import type { IconSvgObject } from './types';

const FiverrIcon: IconSvgObject = [
  ["path", { d: "M6 8H3V12H6V22H10.5V12H15V22H20V8H11V7C11 6.17157 11.6716 5.5 12.5 5.5H15V2H11C8.23858 2 6 4.23858 6 7V8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FiverrIcon;
